import React from 'react';
import { Routes, Route, NavLink } from 'react-router-dom';
import PageHeader from '../../components/shared/PageHeader';

const Placeholder = ({ name }) => (
  <div className="text-center py-20 text-gray-500 dark:text-gray-400">
    <div className="text-5xl mb-5 opacity-25">&#x1f527;</div>
    <h5 className="text-xl font-semibold mb-2 text-gray-700 dark:text-gray-300">{name}</h5>
    <p className="text-sm font-medium text-brand-gold mb-2">Work in Progress</p>
    <p className="text-sm text-gray-400 dark:text-gray-500 max-w-md mx-auto leading-relaxed">
      Our quant team is calibrating the Black-Litterman engine and stress-testing allocation models.
      This module will be live soon &mdash; stay tuned.
    </p>
    <div className="mt-6 inline-block px-4 py-2 rounded-lg bg-gray-100 dark:bg-gray-800 text-xs uppercase tracking-widest text-gray-400 dark:text-gray-500 font-semibold">
      Coming Soon
    </div>
  </div>
);

const tabs = [
  { label: 'Allocation', path: '/saa', end: true },
  { label: 'Returns', path: '/saa/returns' },
  { label: 'Risk', path: '/saa/risk' },
  { label: 'Frontier', path: '/saa/frontier' },
  { label: 'Data', path: '/saa/data' },
];

const SAALayout = () => {
  return (
    <div>
      <PageHeader
        title="Strategic Asset Allocation"
        description="Black-Litterman portfolio optimization"
      />

      <div className="flex gap-1 border-b border-gray-200 dark:border-gray-800 mb-6">
        {tabs.map((tab) => (
          <NavLink
            key={tab.path}
            to={tab.path}
            end={tab.end}
            className={({ isActive }) =>
              `px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${
                isActive
                  ? 'border-brand-gold text-brand-gold'
                  : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600'
              }`
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </div>

      <Routes>
        <Route index element={<Placeholder name="Allocation" />} />
        <Route path="returns" element={<Placeholder name="Returns" />} />
        <Route path="risk" element={<Placeholder name="Risk" />} />
        <Route path="frontier" element={<Placeholder name="Efficient Frontier" />} />
        <Route path="data" element={<Placeholder name="Data" />} />
      </Routes>
    </div>
  );
};

export default SAALayout;
